"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AthenaApi = void 0;
const env_1 = require("../../conf/env");
const base_api_1 = require("./base-api");
/**
 * @description api services for Athena api endpoints
 *
 * @export
 * @class AthenaApi
 * @extends {BaseApi<T>}
 * @template T
 */
class AthenaApi extends base_api_1.BaseApi {
    constructor(authToken, domainPermissionToken) {
        const axiosConfig = {
            baseURL: env_1.ATHENA_API_URL,
            headers: {
                Authorization: `Bearer ${authToken}`,
                "X-Gloow-Domain-Data": domainPermissionToken
            },
            timeout: 20000 // longer timeout as some of the requests can take more time
        };
        super(axiosConfig);
    }
}
exports.AthenaApi = AthenaApi;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXRoZW5hQXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3ByaXZhdGUvYXBpLXNlcnZpY2VzL2F0aGVuYUFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx3Q0FBK0M7QUFDL0MseUNBQXFDO0FBRXJDOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLFNBQWEsU0FBUSxrQkFBVTtJQUUxQyxZQUFhLFNBQWlCLEVBQUUscUJBQTZCO1FBRTNELE1BQU0sV0FBVyxHQUF1QjtZQUN0QyxPQUFPLEVBQUUsb0JBQWM7WUFDdkIsT0FBTyxFQUFFO2dCQUNQLGFBQWEsRUFBRSxVQUFVLFNBQVMsRUFBRTtnQkFDcEMscUJBQXFCLEVBQUUscUJBQXFCO2FBQzdDO1lBQ0QsT0FBTyxFQUFFLEtBQUssQ0FBQyw0REFBNEQ7U0FDNUUsQ0FBQztRQUVGLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUNyQixDQUFDO0NBQ0Y7QUFmRCw4QkFlQyJ9